import ProjectSuitabilityConfig from './ProjectSuitabilityConfig'

export default ProjectSuitabilityConfig
